import "@/App.css";
import ComingSoon from "@/components/ComingSoon";

function App() {
  return <ComingSoon />;
}

export default App;
